<script setup>
  defineOptions({
    name: "ComponentPatientSidebarPatientinputFoldableComplianceBar",
  });

  defineProps({
    max: {
      type: Number,
      default: 4,
    },
    current: {
      type: Number,
      required: true,
    },
  });
</script>

<template>
  <div>
    <div
      v-if="current > 0"
      class="grid h-3 w-full rounded bg-gray-200"
      :style="`grid-template-columns: repeat(${max}, minmax(0, 1fr));`"
    >
      <span
        v-for="index of current"
        :key="index"
        class="h-full bg-mcred"
        :class="{'rounded-s': index === 1, 'rounded-e': index === max}"
      />
    </div>

    <div v-else class="h-3 w-full rounded bg-gray-200">
      <div class="h-full w-2 rounded-s bg-mcred" />
    </div>

    <div class="flex justify-between pt-1 text-xs">
      <slot />
    </div>
  </div>
</template>
